import { MutableRefObject, useCallback } from 'react';

import { RiCheckLine, RiFileCopyLine } from '@remixicon/react';
import type { Editor as TiptapEditor } from '@tiptap/core';

import { ButtonIcon, Tooltip, TooltipTrigger } from '@backstage/ui';

import { useCopyToClipboard } from '@spotify/confidence-core-react';

import { useCollaborativeDocumentContext } from '../contexts';
import { getDocumentMarkdown } from '../utils';

export const CopyAsMarkdownButton = ({
  editorRef,
}: {
  editorRef?: MutableRefObject<TiptapEditor | null>;
} = {}) => {
  const { collaborativeDocument } = useCollaborativeDocumentContext();
  const { copied, copy } = useCopyToClipboard();

  const handleCopy = useCallback(() => {
    const text = getDocumentMarkdown({
      editor: editorRef?.current,
      markdown: collaborativeDocument?.markdown,
      content: collaborativeDocument?.content,
    });
    if (text) {
      void copy(text);
    }
  }, [
    editorRef,
    collaborativeDocument?.markdown,
    collaborativeDocument?.content,
    copy,
  ]);

  return (
    <TooltipTrigger>
      <ButtonIcon
        aria-label="Copy as markdown"
        icon={copied ? <RiCheckLine size={16} /> : <RiFileCopyLine size={16} />}
        onPress={handleCopy}
        size="small"
        variant="tertiary"
      />
      <Tooltip>Copy as markdown</Tooltip>
    </TooltipTrigger>
  );
};
